import React from "react";
import styled from "styled-components";

type ScrollLinkProps = {
  targetId: string;
  label: string;
  isSmooth?: boolean;
};

export const ScrollLink = ({ targetId, label, isSmooth }: ScrollLinkProps) => {
  const handleScrollView = () => {
    const element = document.getElementById(targetId);

    if (element) element.scrollIntoView(isSmooth && { behavior: "smooth" });
  };

  return (
    <StyledScrollLink onClick={handleScrollView}>{label}</StyledScrollLink>
  );
};

const StyledScrollLink = styled.a`
  font: var(--body-medium-400);
  color: var(--pri-blue-4);
  text-decoration: underline;
  cursor: pointer;
`;
